import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Product } from '@shared/models/bracelit/product';
import { Voucher } from '@shared/models/bracelit/voucher';
import { VoucherBlueprint } from '@shared/models/bracelit/voucher-blueprint';
import { VoucherBlueprintService } from '@shared/services/voucher-blueprint.service';

@Component({
  selector: 'app-coupon-details',
  templateUrl: './voucher-details.component.html',
  styleUrls: ['./voucher-details.component.scss'],
  standalone: false
})
export class VoucherDetailsComponent implements OnInit {
  voucher: Voucher;
  voucherBlueprint: VoucherBlueprint;
  voucherBlueprint2 = [];
  products: Product[];
  voucherBlueprint_uses = [];
  voucher_used_uses = [];
  voucher_uses_left = [];
  gastado = 0;
  loading = true;
  voucherLabel = (localStorage.getItem('lang') === 'es') ? 'Bono' : 'Offer';
  tokensLabel1 = (localStorage.getItem('lang') === 'es') ? 'Fichas' : 'Tokens';
  tokensLabel2 = (localStorage.getItem('lang') === 'es') ? 'fichas' : 'tokens';
  tokenLabel2 = (localStorage.getItem('lang') === 'es') ? 'ficha' : 'token';
  leftLabel = (localStorage.getItem('lang') === 'es') ? 'Te quedan' : 'Left';
  backLabel = (localStorage.getItem('lang') === 'es') ? 'Volver' : 'Back';
  leftLabel2 = (localStorage.getItem('lang') === 'es') ? 'Has gastado' : 'You have spent';
  backLabel2 = (localStorage.getItem('lang') === 'es') ? 'Volver' : 'Back';
  messageLabel = (localStorage.getItem('lang') === 'es') ? 'Con estas fichas puedes comprar' : 'With these tokens you can purchase';
  messageMoneyExtra = (localStorage.getItem('lang') === 'es') ? 'Con este bono se recarga un extra de' : 'With this voucher an extra of';
  buyInterval = (localStorage.getItem('lang') === 'es') ? 'Intervalo de compra' : 'Buy interval';
  useInterval = (localStorage.getItem('lang') === 'es') ? 'Intervalo de uso' : 'Use interval';
  maximumToSellText = (localStorage.getItem('lang') === 'es') ? 'Unidades a la venta' : 'Units for sale';
  maximumTimesToRechargeText = (localStorage.getItem('lang') === 'es') ? 'Máximas unidades por persona' : 'Maximum units per person';
  start = (localStorage.getItem('lang') === 'es') ? 'Inicio' : 'Start';
  end = (localStorage.getItem('lang') === 'es') ? 'Fin' : 'End';
  voucher_products_prices = [];

  constructor(public dialogRef: MatDialogRef<VoucherDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private voucherBlueprintService: VoucherBlueprintService) {
    this.init(data);
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
  }

  async init(data): Promise<any> {
    this.voucher = data.voucher;
    this.voucherBlueprint = data.voucherBlueprint;
    if (this.voucherBlueprint === undefined) {
      this.voucherBlueprint2 = await this.voucherBlueprintService.fetchVoucherBlueprint(data.eventId);
      for (let i = 0; i < this.voucherBlueprint2.length; i++) {
        if (this.voucherBlueprint2[i].id === this.voucher.voucherBlueprintId) {
          this.voucherBlueprint = this.voucherBlueprint2[i];
        }
      }
    }

    const voucherBlueprintId = this.voucherBlueprint ? this.voucherBlueprint.id : this.voucher.voucherBlueprintId;
    this.products = await this.voucherBlueprintService.fetchProducts(voucherBlueprintId);
    this.loading = false;

    this.gastado = this.voucher ? (this.voucherBlueprint.uses - this.voucher.usesLeft >= 0 ? this.voucherBlueprint.uses - this.voucher.usesLeft : 0) : 0;
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
